import { render, staticRenderFns } from "./BaiduMap.vue?vue&type=template&id=058798a4&scoped=true&"
import script from "./BaiduMap.vue?vue&type=script&lang=js&"
export * from "./BaiduMap.vue?vue&type=script&lang=js&"
import style0 from "./BaiduMap.vue?vue&type=style&index=0&id=058798a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058798a4",
  null
  
)

export default component.exports